import { render, staticRenderFns } from "./ListVariantsDuplicate.vue?vue&type=template&id=e536dbce&"
import script from "./ListVariantsDuplicate.vue?vue&type=script&lang=js&"
export * from "./ListVariantsDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports